export class Module{
	name: string;
	access: DroitAcces;
}

export enum DroitAcces {
	ReadOnly = 0,
	ReadWrite = 1
}
